// firebase-app-init.ts
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: "AIzaSyCXumwCgs35mvoqsXUWMF5pNUXDn0Sd1Zo",
  authDomain: "digital-iq--hub.firebaseapp.com",
  databaseURL: "https://digital-iq--hub-default-rtdb.firebaseio.com",
  projectId: "digital-iq--hub",
  storageBucket: "digital-iq--hub.firebasestorage.app",
  messagingSenderId: "533848362382",
  appId: "1:533848362382:web:c502e12e8078fbe43ee8df",
  measurementId: "G-2YV0KHMEK2"
  }

const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
